<template>
    <div class="html-view" v-html="html">

    </div>
</template>

<script>
export default {
    name: "HTMLView",
    props: {
        contentData: {
            type: Object,
            required: true
        }
    },
    computed: {
        html() {
            if (this.contentData.content.bodytext) {
                return this.contentData.content.bodytext.replace(/(?:\r\n|\r|\n)/g, '<br>');
            }

            return "";
        },
    }
}
</script>

<style scoped>

</style>